import { styled } from '../../../../utils/styled';
import { propStyles } from '../../../../utils/propStyles';

const DocumentsPaginationWrapper = styled<any, any>(
    'div',
    'documentsPaginationWrapper',
    'documentsGrid'
)`
    ${propStyles};
`;

DocumentsPaginationWrapper.defaultProps = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: 'md',
};

export default DocumentsPaginationWrapper;



// WEBPACK FOOTER //
// ./src/Components/Document/DocumentsGrid/StyledComponents/DocumentsPaginationWrapper.tsx